import * as React from 'react';
import MonoComponent from './MonoComponent';

interface Props {
	style?: Object;
}

interface State {
}

export default class MonoLineComponent extends React.Component<Props, State> {

	render () {
		return <div style={{margin: '1em 0'}}><MonoComponent {...this.props} /></div>;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/shared/MonoLineComponent.tsx